export type CreativeBlockSelectStyles = Record<
  string,
  (provided: Record<string, unknown>) => Record<string, unknown>
>;

/** Advertiser identity row sits above the partner-post panel in the Accounts stack. */
export const CREATIVE_IDENTITY_SELECT_CONTROL_Z = 30;
export const CREATIVE_IDENTITY_SELECT_MENU_Z = 9999;

/** Partner selectors stay below identity; menus still above the partner panel chrome. */
export const CREATIVE_PARTNER_SELECT_CONTROL_Z = 10;
export const CREATIVE_PARTNER_SELECT_MENU_Z = 9990;

export function withCreativeSelectStackOrder(
  base: CreativeBlockSelectStyles,
  controlZIndex: number,
  menuZIndex: number
): CreativeBlockSelectStyles {
  return {
    ...base,
    container: (provided) => ({
      ...(base.container?.(provided) ?? provided),
      position: "relative" as const,
      zIndex: controlZIndex,
    }),
    menu: (provided) => ({
      ...(base.menu?.(provided) ?? provided),
      zIndex: menuZIndex,
    }),
  };
}
